const linksGitData = [
  {
    link: 'https://github.com/bmorelli25/Become-A-Full-Stack-Web-Developer/blob/master/README.md',
    name: 'Become-A-Full-Stack-Web-Developer',
  },
  {
    link: 'https://github.com/EbookFoundation/free-programming-books/blob/master/free-programming-books.md',
    name: 'Free-programming-books',
  },
  {
    link: 'https://github.com/rtivital/react-things/blob/master/README.md',
    name: 'React-things',
  }
];

export default linksGitData;



// WEBPACK FOOTER //
// ./src/assets/linksGitData.js